import React, { useContext } from 'react';
import { ProductContext } from '../context/ProductContext';

const Pager = () => {
  const { page, setPage, totalPages } = useContext(ProductContext);

  if (totalPages <= 1) return null;

  const goTo = (p) => {
    setPage(Math.min(Math.max(p, 1), totalPages));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
    (p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1
  );

  return (
    <div className="flex items-center justify-center gap-1 py-8">
      <button
        onClick={() => goTo(page - 1)}
        disabled={page === 1}
        className="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Prev
      </button>

      {pages.map((p, i) => (
        <React.Fragment key={p}>
          {i > 0 && p - pages[i - 1] > 1 && <span className="px-1 text-gray-400">…</span>}
          <button
            onClick={() => goTo(p)}
            className={`rounded-lg px-3 py-1.5 text-sm font-medium ${
              p === page ? 'bg-brand-600 text-white' : 'text-gray-600 hover:bg-gray-50'
            }`}
          >
            {p}
          </button>
        </React.Fragment>
      ))}

      <button
        onClick={() => goTo(page + 1)}
        disabled={page === totalPages}
        className="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Next
      </button>
    </div>
  );
};

export default Pager;
